import { getConfig } from 'choerodon-ui/lib/configure';
import PromiseMerger from '../_util/PromiseMerger';
export class AttachmentStore {
    constructor() {
        this.batchCallback = (uuids) => {
            const { batchFetchCount } = getConfig('attachment');
            if (batchFetchCount) {
                return batchFetchCount(uuids);
            }
            return Promise.resolve({});
        };
        this.merger = new PromiseMerger(this.batchCallback, { maxAge: 60000, max: 100 });
    }
    fetchCountInBatch(uuid) {
        return this.merger.add(uuid);
    }
}
export default new AttachmentStore();
